module.exports = __webpack_public_path__ + "img/icone_txt.baac151b.png";